import type { ReactNode } from 'react'

import { CatalogListCardContent } from '@/shared/components/catalog/CatalogListCardContent'
import { CatalogListCardMedia } from '@/shared/components/catalog/CatalogListCardMedia'
import { catalogListCardLinkClass } from '@/shared/components/catalog/catalogListCardShell'
import { CatalogItemLink } from '@/shared/components/CatalogItemLink'
import { cn } from '@/shared/lib/utils'

type StudioCatalogCardProps = {
  href: string
  title: string
  description?: string
  coverUrl?: string | null
  coverAlt?: string
  fallback: ReactNode
  mediaClassName?: string
  badges?: ReactNode
  meta?: ReactNode
  overlayActions?: ReactNode
  footer?: ReactNode
  footerLabel?: string
  bottomActions?: ReactNode
  className?: string
}

/** 创作中心统一目录卡片 */
export function StudioCatalogCard({
  href,
  title,
  description,
  coverUrl,
  coverAlt = '',
  fallback,
  mediaClassName,
  badges,
  meta,
  overlayActions,
  footer,
  footerLabel,
  bottomActions,
  className,
}: StudioCatalogCardProps) {
  const body = (
    <>
      <CatalogListCardMedia
        className={cn('bg-[#0b0b13]', mediaClassName)}
        coverUrl={coverUrl}
        coverAlt={coverAlt}
        fallback={fallback}
      >
        {badges}
        {overlayActions ? (
          <div className="absolute right-2 top-2 z-[3] flex items-center gap-1">{overlayActions}</div>
        ) : null}
      </CatalogListCardMedia>

      <CatalogListCardContent
        title={title}
        summary={description}
        meta={meta}
        footer={footer}
        footerLabel={footerLabel}
      />
    </>
  )

  return (
    <li className={cn('group', className)}>
      <article className={catalogListCardLinkClass(bottomActions ? 'hover:translate-y-0' : undefined)}>
        <CatalogItemLink href={href} className="flex flex-col">
          {body}
        </CatalogItemLink>
        {bottomActions ? (
          <div className="flex flex-wrap items-center justify-end gap-1.5 px-3 pb-2 pt-0">
            {bottomActions}
          </div>
        ) : null}
      </article>
    </li>
  )
}

export function studioCatalogCardShellClass(...extra: Array<string | false | null | undefined>) {
  return catalogListCardLinkClass('pointer-events-auto cursor-default hover:translate-y-0', ...extra)
}

export { catalogListCardLinkClass }
